import React, { useEffect, useState } from 'react'

const MoveToTop = () => {
    const [showBtn, setShowBtn] = useState(false)

    useEffect(() => {
        document.addEventListener('scroll', () => {
            setShowBtn(window.scrollY > 100 ? true : false)
        })
    }, [])

    return (
        <div className={`move_to_top  ${showBtn ? 'd-flex' : 'd-none'}`} data-aos="fade-up">
            
            <a href="#" className='theme-btn btn-one shadow px-3  py-2 fs-6 text-white'> <i className='bi bi-telephone-fill'></i> </a> 
            <a href="tel:+44 7380 851496" className='theme-btn btn-one shadow px-3 py-2 fs-6 text-white'>+44 7380 851496</a> 
            <a href="tel:0116 210 2688" className='theme-btn btn-one shadow px-3 py-2 fs-6 text-white d-md-inline-block d-none'>0116 210 2688</a>
            <button className='px-3 py-2 rounded bg-red shadow ms-2' onClick={() => window.scrollTo(0, 0)}>
                <i className='bi bi-chevron-double-up'></i>
            </button>
        </div>
    )
}

export default MoveToTop